// extracted by mini-css-extract-plugin
export var wrapper = "ScrollSlider-module--wrapper--ec078";